module.exports = __webpack_public_path__ + "img/Icon_Gift_dashboard.b52c32ba.svg";